// Forma de pago de cliente_servicio.pago — el value es lo que se guarda en BD y lo
// que usa la logica de facturacion (ej. PrefacturaServicioModal compara contra
// "adelantado"), el label es solo para mostrar en pantalla.
export const PAGO_OPTIONS = [
  { value: "vencido", label: "Mes Vencido" },
  { value: "adelantado", label: "Mes Anticipado" },
  { value: "trimestral", label: "Trimestral" },
  { value: "semestral", label: "Semestral" },
  { value: "anual", label: "Anual" },
];

export const getPagoLabel = (value) =>
  PAGO_OPTIONS.find((p) => p.value === value)?.label || value || "";
